module.exports = "/assets/addb32f78de1cd71f3e1f175a0fa3abb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4U.png
// module id = 1046
// module chunks = 0